import { useState } from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import Modal from "../../../../parts/modal-new";

const EditEmailModal = ({ client, onClose }) => {
  const { t } = useTranslation(["coaching-portal", "common"]);
  const [email, setEmail] = useState(client.email);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    submit("/coaching-portal/access-requests/edit-email", {
      method: "POST",
      body: {
        clientId: client._id,
        newEmail: email,
      },
    });

    setIsSubmitting(false);
    onClose();
  };

  return (
    <Modal
      title={t("accessRequests.modalTitle")}
      onClose={onClose}
      className="edit-email-modal"
    >
      <form onSubmit={handleSubmit} className="body">
        <div className="modal-content">
          <div className="form-group">
            <label htmlFor="member-name">
              {t("accessRequests.modalMemberNameLabel")}
            </label>
            <input
              type="text"
              id="member-name"
              value={client.name}
              disabled
              className="text-input"
            />
          </div>
          <div className="form-group">
            <label htmlFor="member-email">
              {t("accessRequests.modalEmailLabel")}
            </label>
            <input
              type="email"
              id="member-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="text-input"
              required
            />
          </div>
        </div>
        <footer className="px-0!">
          <button
            type="button"
            data-button-type="secondary"
            onClick={onClose}
            disabled={isSubmitting}
            data-action="cancel"
          >
            {t("common:cancel")}
          </button>
          <button
            type="submit"
            data-button-type="primary"
            disabled={isSubmitting || email === client.email || !email}
          >
            {isSubmitting ? t("accessRequests.saving") : t("common:save")}
          </button>
        </footer>
      </form>
    </Modal>
  );
};

export default EditEmailModal;
